/**
 * Mapeo de columnas para Excel de importacion de Legajos
 *
 * Si se necesita cambiar el orden de las columnas en el Excel,
 * modificar los indices aqui y en Backend/app/Constants/ExcelColumns/LegajoExcelColumns.php
 */
export const LEGAJO_COLUMNS = {
  NRO_LEGAJO: 0,
  NOMBRE: 1,
  APELLIDO: 2,
  TIPO_DOCUMENTO: 3,
  DOCUMENTO: 4,
  CUIL: 5,
  SUCURSAL: 6,
  SECTOR: 7,
  PUESTO: 8,
  FECHA_INGRESO: 9,
  FECHA_NACIMIENTO: 10,
  GENERO: 11,
  NACIONALIDAD: 12,
  ESTADO_CIVIL: 13,
  NIVEL_ESTUDIO: 14,
  DISCAPACIDAD: 15,
  DIRECCION: 16,
  CODIGO_POSTAL: 17,
  LOCALIDAD: 18,
  PROVINCIA: 19,
  TELEFONO: 20,
  EMAIL: 21,
  REFERENCIA_EXTERNA: 22,
  OBSERVACIONES: 23,
};

/**
 * Mapeo de columnas para Excel de importacion del Organigrama
 *
 * Si se necesita cambiar el orden de las columnas en el Excel,
 * modificar los indices aqui y en Backend/app/Constants/ExcelColumns/OrgChartExcelColumns.php
 */
export const ORG_CHART_COLUMNS = {
  NOMBRE: 0,
  TIPO: 1,
  DEPENDE_DE: 2,
  SUCURSAL: 3,
  SECTOR: 4,
  REFERENCIA_EXTERNA: 5,
  NRO_LEGAJO_RESPONSABLE: 6,
  NRO_LEGAJO_SUPLENTE: 7,
  ORDEN: 8,
  ESTADO: 9,
  DESCRIPCION: 10,
};
